import { Components } from "formiojs";

import MiproVariableFieldEditData from "./edit-form/mipro-variable-field-edit-data";
import MiproVariableFieldEditDisplay from "./edit-form/mipro-variable-field-edit-display";
import MiproVariableFieldEditValidation from "./edit-form/mipro-variable-field-edit-validation";

export default function (...extend: any[]): any {
    return Components.baseEditForm([
        {
            key: "display",
            components: MiproVariableFieldEditDisplay
        },
        {
            key: "data",
            components: MiproVariableFieldEditData
        },
        {
            key: "validation",
            components: MiproVariableFieldEditValidation
        }
    ], ...extend);
}
